import React from 'react';
import styles from './EvaluationColorSelector.module.scss';
import ColorManager from 'components/UI/V3/ColorManager/ColorManager';
import { FieldError } from '@spike/model';
import { getErrorMessage } from './Validations';

interface EvaluationColorSelectorProps {
    selectedColor: string | null;
    onUpdateColor: (color: string | null) => void;
    errors: Array<FieldError>;
}

export const EvaluationColorSelector: React.FC<EvaluationColorSelectorProps> = ({
    selectedColor,
    onUpdateColor,
    errors
}) => {
    return (
        <div className={styles.colorSection}>
            <ColorManager
                id="evaluation-color"
                color={selectedColor}
                onChange={onUpdateColor}
                label="Color Code"
                labelDescription="Select a color to identify this service."
                error={getErrorMessage(errors, 'color')}
            />
        </div>
    );
};

export default EvaluationColorSelector;
